import React from "react";

interface TableCheckboxProps {
  checked: boolean;
  onChange: () => void;
  id?: string;
  className?: string;
  label?: string;
  labelPosition?: "left" | "right" | "up" | "down";
}

const TableCheckbox: React.FC<TableCheckboxProps> = ({
  checked,
  onChange,
  id,
  className = "",
  label,
  labelPosition = "right",
}) => {
  return (
    <div
      className={`inline-flex select-none items-center justify-center ${className}`}
      style={{
        flexDirection:
          labelPosition === "up"
            ? "column-reverse"
            : labelPosition === "down"
            ? "column"
            : labelPosition === "left"
            ? "row-reverse"
            : "row",
      }}
    >
      {/* Caja visual + input real */}
      <div className="relative flex items-center justify-center">
        <input
          type="checkbox"
          id={id}
          className="absolute h-5 w-5 opacity-0 cursor-pointer"
          checked={checked}
          onChange={onChange}
        />
        <div
          className={`pointer-events-none flex h-5 w-5 items-center justify-center rounded border transition-all ${
            checked
              ? "border-primary bg-gray dark:bg-transparent"
              : "border-gray-300 dark:border-gray-500"
          }`}
        >
          <span
            className={`h-2.5 w-2.5 rounded-sm transition-all ${
              checked ? "bg-primary" : "bg-transparent"
            }`}
          />
        </div>
      </div>

      {/* Texto visual (no clickeable) */}
      {label && (
        <span
          className={`text-sm text-gray-700 dark:text-gray-300 ${
            labelPosition === "left" || labelPosition === "right" ? "ml-1" : "mt-1"
          }`}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default TableCheckbox;
